import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { classNames } from '~/utils/classNames';

/**
 * TODO: Fold these items into the existing Dropdown components in
 * `packages/bolt/app/components/ui/Dropdown.tsx` as then we can have consistently
 * styled Dropdowns. However, at the moment the new menu is going to look a bit different
 * to the existing dropdown so for now we'll keep them separate. Once we get
 * further into the new Header implementation it's possible the components
 * using those other Dropdown components will be removed so may as well hold on for now.
 * I think there are other places using the Radix Dropdown directly too that could be updated.
 */
export type MenuDropdownItemProps = DropdownMenu.DropdownMenuItemProps;

export function MenuDropdownItem(props: MenuDropdownItemProps) {
  return (
    <DropdownMenu.Item
      {...props}
      className={classNames(
        'w-full rounded-sm flex items-center gap-2 px-2 py-1.5 cursor-pointer outline-none data-[disabled]:cursor-not-allowed data-[disabled]:op-50 hover:bg-bolt-elements-item-backgroundActive ',
        props.className,
      )}
    ></DropdownMenu.Item>
  );
}

export type MenuDropdownSubTriggerProps = DropdownMenu.DropdownMenuSubTriggerProps;

export function MenuDropdownSubTrigger({ className, ...props }: MenuDropdownSubTriggerProps) {
  return (
    <DropdownMenu.SubTrigger
      {...props}
      className={classNames(
        'w-full rounded-sm flex items-center gap-2 px-2 py-1.5 cursor-pointer outline-none data-[disabled]:cursor-not-allowed data-[disabled]:op-50 hover:bg-bolt-elements-item-backgroundActive',
        className,
      )}
    />
  );
}

export type MenuDropdownSubContentProps = DropdownMenu.DropdownMenuSubContentProps;

export function MenuDropdownSubContent({ className, sideOffset, ...props }: MenuDropdownSubContentProps) {
  return (
    <DropdownMenu.SubContent
      {...props}
      sideOffset={sideOffset ?? 2}
      className={classNames(
        'border border-bolt-elements-borderColor rounded-md overflow-hidden select-none bg-bolt-elements-background-depth-2 min-w-[200px] z-visibility-dropdown text-sm',
        className,
      )}
    />
  );
}

export type MenuDropdownCheckboxItemProps = DropdownMenu.DropdownMenuCheckboxItemProps;

export function MenuDropdownCheckboxItem({ className, ...props }: MenuDropdownCheckboxItemProps) {
  return (
    <DropdownMenu.DropdownMenuCheckboxItem
      {...props}
      className={classNames(
        'w-full rounded-sm flex items-center gap-2 px-2 py-1.5 cursor-pointer outline-none data-[disabled]:cursor-not-allowed data-[disabled]:op-50 hover:bg-bolt-elements-item-backgroundActive',
        className,
      )}
    />
  );
}

export type MenuDropdownItemIndicatorProps = DropdownMenu.DropdownMenuItemIndicatorProps;

export function MenuDropdownItemIndicator({ className, ...props }: MenuDropdownItemIndicatorProps) {
  return (
    <DropdownMenu.ItemIndicator
      {...props}
      className={classNames('ml-auto inline-flex w-[25px] items-center justify-center', className)}
    />
  );
}

export type DropdownSeparatorProps = DropdownMenu.DropdownMenuSeparatorProps;

export function MenuDropdownSeparator({ className }: DropdownSeparatorProps) {
  return (
    <DropdownMenu.Separator className={classNames('h-px bg-bolt-elements-borderColor opacity-70 my-1', className)} />
  );
}
